/**
 * TOGGLE_MENU
 */
export const TOGGLE_MENU = 'MENU.TOGGLE_MENU';
